import { Checkbox, Text } from '@thefarmersfront/kitchen';

import { FormField } from '~/components/common';

import type { TypeOwnerDetail } from '~/types/vender.types';

import styles from './VenderConfirmLogisticsInfoSection.module.scss';

const VenderConfirmLogisticsInfoSection = ({ venderInfo }: { venderInfo: TypeOwnerDetail | null }) => {
  if (!venderInfo) return <></>;

  return (
    <div className={styles['section-container']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold" element="p">
        물류유형 정보
      </Text>
      <div className={styles['section-content']}>
        <FormField
          label="유형"
          contents={
            <>
              <Checkbox size="medium" label="N배송" disabled checked={venderInfo.fulfillmentTypeFlag} />
              <Checkbox size="medium" label="N판매자배송" disabled checked={venderInfo.deliveryTypeFlag} />
            </>
          }
          contentsClassName={styles['checkbox-group']}
          labelClassName={styles['checkbox-group-label']}
        />
      </div>
    </div>
  );
};

export default VenderConfirmLogisticsInfoSection;
